import React from "react";
import set from "@rill/set";

import Catalog from "./Catalog";

const catalogController = (app) => {
  app
    .use(set("heading", ["Coaching", "Catalog"]))
    .get("/catalog", async ({ load, locals, res, req }) => {
      await load("exerciseCatalog", {});

      const { activeUser, exerciseCatalog = [], activeUserToRequest } = locals;
      const { exerciseLibrary } = activeUserToRequest;
      const userExercises = new Set();
      // add all the exercises as "{primary}{movement}" to filter out duplicates later
      Object.entries(exerciseLibrary).forEach(([primary, movements]) => {
        movements.forEach((item) => {
          const exercise = `${primary}${String(item.movement)
            .trim()
            .toLowerCase()}`;
          userExercises.add(exercise);
        });
      });

      // filter out exercises that the user already has in their library
      locals.exerciseCatalog = exerciseCatalog.filter((ex) => {
        const exercise = `${ex.primary}${String(ex.movement)
          .trim()
          .toLowerCase()}`;
        return !userExercises.has(exercise);
      });

      res.body = <Catalog />;
    });
};

export default catalogController;
